import styled from 'styled-components';
import PropTypes from 'prop-types';
import breakpoint from 'styled-components-breakpoint';

const ChannelHeader = styled.h3`
    font-size: 20px;
    line-height: 32px;
    text-align: ${props => (props.align ? props.align : 'left')};
    display: flex;
    margin-bottom: 20px;
    padding-left: 5px;
    justify-content: flex-start;
    text-transform: uppercase;
    ${() => breakpoint('xs', 'md')`
        justify-content: center;
        align-items: center;
    `}
`;

ChannelHeader.propTypes = {
    align: PropTypes.string
};

export default ChannelHeader;

export const ChannelSubHeader = styled(ChannelHeader)`
    color: #666666;
    font-size: 20px;
    margin: 40px 0;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/header/ChannelHeader.js